export default "__VITE_ASSET__CvNHsqjC__"